var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "header__top",
      style: _vm.config
        ? { backgroundColor: _vm.config.background_color + " !important" }
        : {},
    },
    [
      _c("button", {
        staticClass: "action-icon close",
        attrs: { "aria-label": _vm.$gettext("Cerrar chat"), tabindex: "0" },
        on: {
          click: _vm.closeChat,
          keyup: [
            function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              )
                return null
              return _vm.closeChat.apply(null, arguments)
            },
            function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "space", 32, $event.key, [
                  " ",
                  "Spacebar",
                ])
              )
                return null
              return _vm.closeChat.apply(null, arguments)
            },
          ],
        },
      }),
      _c("div", [
        _c("p", { staticClass: "bold__greeting", attrs: { tabindex: "0" } }, [
          _vm._v(_vm._s(_vm.$gettext("Tema:") + " " + _vm.currentType)),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }